module.exports = __webpack_public_path__ + "img/unnamed.7dc4adec.png";